import { DateStringValue } from '@unistocks/components/calendar/types';
import { createDate } from '@unistocks/shared/utils/util';

/**
 * The 12 months of `year` laid out as a 4-row × 3-column grid, each cell the
 * first day of that month in `yyyy-MM-dd`. 1:1 port of @mantine/dates.
 */
export function getMonthsData(year: DateStringValue): DateStringValue[][] {
  const startOfYear = createDate(year).startOf('year');

  const results: DateStringValue[][] = [[], [], [], []];
  let currentMonthIndex = 0;

  for (let i = 0; i < 4; i += 1) {
    for (let j = 0; j < 3; j += 1) {
      results[i]!.push(startOfYear.plus({ months: currentMonthIndex }).toISODate());
      currentMonthIndex += 1;
    }
  }

  return results;
}
